import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M85.796 306.484l-51.665 51.667 477.35 477.249 477.296-477.251-51.669-51.667-425.659 425.674-425.654-425.673zM85.796 306.484z\" p-id=\"2830\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol